const ItemGenerator = require('../../../game_items/ItemGenerator.js');
const Bow = require('../../../game_items/equipment/off_hand/Bow.js');
const MedTorsoe = require('../../../game_items/equipment/torsoe/MedTorsoe.js');
const getMobEquipmenAssignmentFromBags = require('./getMobEquipmenAssignmentFromBags');

const skeletal_archer = (level) => {
  const handle = 'skeletal_archer';
  const types = ['archer', 'skeleton', 'undead'];
  const bags = [
    {
      items: [
        ItemGenerator.getCavernsMobItem(MedTorsoe, level),
        ItemGenerator.getCavernsMobItem(Bow, level),
      ].map((item) => ({ value: item })),
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'skeletal_archer_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          arrow_shot: {
            handle: 'arrow_shot',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          range: {
            handle: 'range',
            level: Math.min(10, Math.round(1 + bound_level / 100)),
            passive: true,
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(2 + bound_level * 0.3 + Math.random() * 3),
      perception: Math.round(3 + bound_level * 0.55 + Math.random() * 3),
      mana: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
      toughness: Math.round(2 + bound_level * 0.2 + Math.random() * 3),
      strength: Math.round(3 + bound_level * 0.55 + Math.random() * 3),
      willpower: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
      dexterity: Math.round(4 + bound_level * 0.85 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => ['dps_ranged', 'interference', 'dps_close', 'tank', 'support'],
    xpValue: level * 55,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: ['dps_ranged', 'interference', 'dps_close', 'tank', 'support'],
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [{ value: 'move' }, { value: 'melee_attack' }, { value: 'arrow_shot' }],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = skeletal_archer;
